import { api } from "../../App/services/api";
// Define o bloqueio visual dos boxes conforme o status atual do carregamento dos seus dados
export var getContainerStyle = function (isLoading) { return ({
    opacity: isLoading ? 0.3 : 1,
    pointerEvents: isLoading ? 'none' : 'auto',
}); };
function getTokensData() {
    return api.get('/reports/tokens');
}
function getTokensPerMonthReport() {
    return api.get('/reports/tokens-per-month');
}
function getTokensPerProductReport() {
    return api.get('/reports/tokens-per-product');
}
function getSubscribersData() {
    return api.get('/reports/subscribers');
}
function getMarginsWithProducts() {
    return api.get('/reports/margins');
}
function getContentSupplierProducts() {
    return api.get('/content_suppliers_products');
}
function paginate(url, customer_success_id, plan_id, erp_id) {
    if (customer_success_id) {
        url += "&customer_success_id=".concat(customer_success_id);
    }
    if (plan_id) {
        url += "&plan_id=".concat(plan_id);
    }
    if (erp_id) {
        url += "&erp_id=".concat(erp_id);
    }
    return api.get(url);
}
export default {
    getTokensData: getTokensData,
    getSubscribersData: getSubscribersData,
    getTokensPerMonthReport: getTokensPerMonthReport,
    getTokensPerProductReport: getTokensPerProductReport,
    getMarginsWithProducts: getMarginsWithProducts,
    getContentSupplierProducts: getContentSupplierProducts,
    paginate: paginate
};
